import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "antd";

import { red } from "utils/constants/colors";

const InvalidProfileIcon = styled(FontAwesomeIcon)`
  color: ${red};
  font-size: 14px;
`;

function InvalidClusterProfileIcon({ isInvalid, invalidReason }) {
  if (!isInvalid) {
    return null;
  }

  return (
    <Tooltip position="top" title={invalidReason}>
      <InvalidProfileIcon icon={faExclamationCircle} />
    </Tooltip>
  );
}

export default InvalidClusterProfileIcon;
